<template>
  <v-dialog v-model="show" max-width="480" persistent>
    <v-card>
      <v-card-title>{{ $t("finance_new_platform_payment") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <text-field
            v-model.number="form.amount"
            :label="$t('finance_amount_currency', { currency: restaurantCurrency })"
            type="number"
            kind="money"
            :rules="[rules.required, rules.positive]"
          />
          <text-field
            v-model="form.period"
            :label="$t('finance_period_label')"
            prependInnerIcon="mdi-calendar-range-outline"
            :rules="[rules.required]"
          />
          <text-area v-model="form.note" :label="$t('finance_comment_optional')" rows="2" />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">{{ $t("finance_cancel") }}</v-btn>
        <primary-button :loading="saving" @click="submit">{{ $t("finance_save") }}</primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const emptyForm = () => ({ amount: 0, period: "", note: "" });

export default {
  name: "PlatformPaymentFormDialog",

  props: {
    value: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },

  data() {
    return {
      valid: true,
      form: emptyForm(),
      rules: {
        required: (v) => (v !== null && v !== undefined && v !== "") || this.$t("finance_required_field"),
        positive: (v) => Number(v) > 0 || this.$t("finance_amount_must_be_positive"),
      },
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(isOpen) {
      if (!isOpen) return;
      this.form = emptyForm();
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("save", {
        amount: Number(this.form.amount),
        period: this.form.period,
        note: this.form.note || undefined,
      });
    },
  },
};
</script>
